//
// Generated class TaxRegimeType
//

/// <reference path="TaxRegimeType_ManagedObject.ts" />

class TaxRegimeType extends TaxRegimeType_ManagedObject
{

}
